import React, {Component} from 'react';
import DefaultLayout from 'layouts/Default';
import {logPageView} from 'services/analytics';
import RouteURLs from 'RouteURLs';
import './index.scss';

export default class CookiesPage extends Component<any, any> {
  componentDidMount(): void {
    logPageView(RouteURLs.COOKIES, 'Cookies');
  }

  render() {
    return <DefaultLayout id="cookies-page">
      <h1>Cookies</h1>
      <p>Cookies are small files saved on your phone, tablet or computer when you visit a website.</p>
      <p>We use cookies to make sook.space work and collect information about how you use our service.</p>
      <h2>Essential cookies</h2>
      <p>Essential cookies keep your information secure while you use this site.
        We do not need to ask permission to use them.</p>
      <table className="cookies-list">
        <thead>
          <tr>
            <th>Name</th>
            <th>Purpose</th>
            <th>Expires</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>sook.session</td>
            <td>Used to keep you signed in</td>
            <td>7 days</td>
          </tr>
          <tr>
            <td>cookiesAccepted</td>
            <td>Saves your cookie consent settings</td>
            <td>Never</td>
          </tr>
        </tbody>
      </table>
      <h2>Analytics cookies (optional)</h2>
      <p>With your permission, we use Google Analytics to collect data about how you use sook.space.
        This information helps us to improve our service.</p>
      <p>Google is not allowed to use or share our analytics data with anyone.</p>
      <p>Google Analytics stores anonymised information about:</p>
      <ul>
        <li>how you got to sook.space</li>
        <li>the pages you visit on sook.space and how long you spend on them</li>
        <li>any errors you see while using sook.space</li>
      </ul>
      <table className="cookies-list">
        <thead>
          <tr>
            <th>Name</th>
            <th>Purpose</th>
            <th>Expires</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>_ga</td>
            <td>Checks if you’ve visited sook.space before. This helps us count how many people visit our site.</td>
            <td>2 years</td>
          </tr>
          <tr>
            <td>_gid</td>
            <td>Checks if you’ve visited sook.space before. This helps us count how many people visit our site.</td>
            <td>24 hours</td>
          </tr>
        </tbody>
      </table>
      <h2>How to manage cookies</h2>
      <p>Most browsers allow you to manage cookies saved on your device – just head to the help section of your browser.
        But don’t forget, if you modify your settings to block all cookies, you may not be able to access parts of our
        site or our service.</p>
    </DefaultLayout>;
  }
}